const customIcons = Array(


    // Template Icon
    {
      prefix: 'ncr',
      iconName: 'logo-icon',
      icon: [
        95, 95,
        [],
        null,
        'M55.9,0H76v65.5L57.1,78.4c-0.7,0.5-1.3,0.2-1.3-0.7V0H55.9z M0.5,1.8l30.1,17c0.7,0.4,1.2,1.2,1.2,2V60 c0,0.7,0.4,1.6,0.9,2l18,16.3c0.6,0.6,1.1,0.3,1.1-0.5V0H1C0,0-0.4,1.3,0.5,1.8z M79.9,0v50.8v12L98,50.5c1.1-0.8,2-2.1,2-3.8V0 H79.9z'
      ]
    },
    
  )